import _ from 'lodash';

/**
 * centralised set of cloudinary functions
 * most require the passing in of a source network and source id
 */

/////////////////////
// Private methods //
/////////////////////

function _fixNetworkName(networkName) {
  switch (networkName) {
    case 'googleplus':
      return 'gplus';
    case 'instagram':
      return 'upload';
    case 'web':
    default:
      return 'twitter'; // by defining the default network as twitter, the fallback to our default profile image will always work, even for unsupported networks
  }
}

function _fixImage(networkName, username, userId) {
  return networkName === 'instagram' ?
    'instagram_default.png' :
    !!userId && userId.replace(/\D/g, '') ?
    userId.replace(/\D/g, '') + '.jpg' :
    '0.jpg'; // just a little safety - this will remove any non-numerics from the id
}

function _getAvatarTemplate(avatarRef = '') {
  const _avatarEls = avatarRef.split(':');
  const _network = _avatarEls[0];
  const _username = _avatarEls[1] || '';
  const _userId = _avatarEls[2];
  return {
    displayURL:   App.globalContext.cloudinary.displayURL,
    defaultImage: 'default-avatar.png',
    network:      _fixNetworkName(_network),
    image:        _fixImage(_network, _username, _userId),
    width:        50,
    height:       50,
  };
}

/////////////////////
// Public methods //
/////////////////////

function avatarUrlFromRef(avatarRef) {
  const template = _getAvatarTemplate(avatarRef);
  return `${template.displayURL}/image/${template.network}/w_${template.width},h_${template.height},d_${template.defaultImage}/${template.image}`;
}

export default { avatarUrlFromRef };
